import React, { useEffect, useState, useCallback, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import loader_video from "../assets/loaderaltra.gif";

import baricon from "../assets/bar-graph.png";
import lineicon from "../assets/minus.png";
import lineicon2 from "../assets/minus_red.png";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { Space } from "antd";



import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, Cell , ReferenceLine , Customized
} from 'recharts';
import { IoArrowBack } from "react-icons/io5";

const VisualisationComparePage = () => {
  const navigate = useNavigate();

 
  const [MainLoading , setMainLoading] = useState(true)

  
  const [country, setCountry] = useState("");
  const [event, setEvent] = useState("");

  const [selectedTime, setSelectedTime] = useState(1);
  const [optionValue, setOptionValue] = useState("6");
const [eventRange , setEventRange] = useState("6");


  const UKHeaders = [
    { name: "GBP/USD", id: "gbpusd" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "GBP/CAD", id: "gbpcad" },
  ];
  const USHeaders = [
    { name: "GBP/USD", id: "gbpusd" },
    { name: "USD/JPY", id: "usdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
    { name: "EUR/USD", id: "eurusd" },
    { name: "USD/CHF", id: "usdchf" },
    { name: "AUD/USD", id: "audusd" },
    { name: "USD/CAD", id: "usdcad" },
  ];
  const JPHeaders = [
    { name: "USD/JPY", id: "usdjpy" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "CAD/JPY", id: "cadjpy" },
  ];
  const CAHeaders = [
    { name: "USD/CAD", id: "usdcad" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "AUD/CAD", id: "audcad" },
    { name: "GBP/CAD", id: "gbpcad" },
  ];
  const CHEHeaders = [
    { name: "USD/CHF", id: "usdchf" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "CAD/CHF", id: "cadchf" },
  ];
  const EUHeaders = [
    { name: "EUR/USD", id: "eurusd" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "EUR/CAD", id: "eurcad" },
  ];
  const AUHeaders = [
    { name: "AUD/USD", id: "audusd" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "AUD/CAD", id: "audcad" },
  ];
  const NZHeaders = [
    { name: "NZD/USD", id: "nzdusd" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "NZD/CAD", id: "nzdcad" },
  ];

 

      const handleOptionChange = (value)=>{
        setEventRange(value);
        setOptionValue(value)
        // console.log("value", value)
      }


  const handlegoback = () => {
    navigate("/user/economicdata");
  };


  // <------third table averge movement varients are calculating here final table-------->

 

  // <----hi ashima here is the today 14-02-2024 new code starts------->


  // <---for testing now bro final is above ----->


  const [loading_forgraphs, setloading_forgraphs] = useState(true);

  const [loading_forgraphs_1stGraph_flat, setloading_forgraphs_1stGraph_flat] = useState(true);

  //  <-------3rd graph---->
  const [loading_forgraphs_3rdgraph, setloading_forgraphs_3rdgraph] = useState(true);
  const [
    loading_forgraphs_3rdgraph_flat0,
    setloading_forgraphs_3rdGraph_flat0,
  ] = useState(true);

  const [loading_forgraphs_4thgraph, setloading_forgraphs_4thgraph] = useState(true);
  const [loading_forgraphs_4thgraph_flat0, setloading_forgraphs_4thgraph_flat0] = useState(true);
  
  const [volatilityImpact_firsttable , setVolatilityImpact_firsttable ] = useState("")
  const [volatilityImpact_firsttable_nonzero , setVolatilityImpact_firsttable_nonzero ] = useState("")
  const [volatilityImpact_firsttable_zero , setVolatilityImpact_firsttable_zero ] = useState("");




    // <----new code starts from here----->
    const [volatilityImpact_secondtable ,setVolatilityImpact_secondtable ] = useState("")

    const [volatilityImpact_secondtable_flatPOS_flatNEV , setVolatilityImpact_secondtable_flatPOS_flatNEV ] = useState("")
    const allOptions = ["1min", "5min", "15min", "60min"];


  const [selectedEventTypes, setSelectedEventTypes] = useState(allOptions);


    const getFirstTabledata = async ()=>{
      try{
          const urlParams = new URLSearchParams(window.location.search);
          const eventName = decodeURIComponent(urlParams.get("eventName"));
          const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
        
          // const urlParams = new URLSearchParams(window.location.search);
          const eventId = decodeURIComponent(urlParams.get("eventId"));
        //   setLoading(true);
          setEvent(eventName);
          setCountry(eventcountry);
          // console.log("selectedEventTypes" , selectedEventTypes);
          
        //   const selectedEventTypes = ["1min", "5min" , "15min" , "60min" ];
          const response = await axios.get(`${process.env.REACT_APP_URL}/user/geteventtable/${eventId}`,
            {
              params: {
                eventRange: eventRange,
                eventType: selectedEventTypes,
                
              },
            } 
          )
        
          // console.log("hi event range after api" , eventRange)
          
          // const res_data = response.data.volatilityEvent.data;
          const res_data = response.data.volatilityEvent.data.output;
          const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
          const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
          const sorted_res_data = res_data.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
          const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
          const sorted_res_data_zero = res_data_zero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
          // console.log("sorted_res_data---------main thing-->" , response.data);
          // console.log("sorted_res_data_zero" , sorted_res_data_zero);
          setVolatilityImpact_firsttable(sorted_res_data);
          setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
          setVolatilityImpact_firsttable_zero(sorted_res_data_zero);
          
          // setLoading_3rdtable(true);
  
          // <----second table---->
          const second_table_res_data = response.data.event
          .data.output
          const second_table_res_data_nonzero = response.data.event
          .data.nonZeroEvent
          
          const second_table_res_data_zero = response.data.event
          .data.zeroEvent
          const second_table_res_data_flatPOS_flatNEV= response.data.event.data.postiveNegative
  
          // console.log("second_table_res_data" , second_table_res_data)
          // console.log("second_table_res_data_nonzero" , second_table_res_data_nonzero)
          // console.log("second_table_res_data_zero" , second_table_res_data_zero)
          // console.log("second_table_res_data_flatPOS_flatNEV" , second_table_res_data_flatPOS_flatNEV)
  
          setVolatilityImpact_secondtable(second_table_res_data)
          // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
          // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
          setVolatilityImpact_secondtable_flatPOS_flatNEV(second_table_res_data_flatPOS_flatNEV)
        //   setLoading(false);
         
  
  
      }
      catch(error){
          console.log("error" , error)
      }
    }

 
    useEffect(()=>{
      getFirstTabledata();

      handleOptionChange();
    
      },[eventRange ])
    
  
  const [state, setState] = useState({
    series: [],
   
    
    options: {
      chart: {
        height: 350,
        type: "line",
        // background: "#5a2989", // Solid dark background for better contrast
      },
      title: {
        text: ``,
        style: { color: "#686868" },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        theme: "dark",
        y: {
          formatter: function (val, context) {
            // here context is giving us extra info like which series/point we are on.
            const seriesName = context.w.config.series[context.seriesIndex].name;
           
      
            // Optional: Different formatting per series
            if (seriesName.includes("%")) {
              return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2)) + "%";
            } else {
              return val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
            }
          }
        }
      },
      xaxis: {
        labels: {
          style: { colors: "#686868" },
        },
      },
      yaxis: [
        {
          title: {
            text: "Average Movement (%)",
            style: { color: "#686868" },
          },
          labels: {
            formatter: function (val) {
              //here i ma checking that its a full number or not?
              return (
                (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) +
                "%"
              );
            },
            style: { colors: "#686868" },
          },
        },
        {
          opposite: true,
          title: {
            text: "Average Movement (points)",
            style: { color: "#686868" },
          },
          labels: {
            formatter: function (val) {
              return val % 1 === 0
                ? val.toFixed(0)
                : parseFloat(val.toFixed(2));
            },
            style: { colors: "#686868" },
          },
        },
      ],
      stroke: { width: [0, 3 , 3 , 3 , 3] }, // column and line corners width
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },
    
      // REMOVE OPACITY FROM BARS
      plotOptions: {
        bar: {
          columnWidth: "24%", 
          
          colors: {
            ranges: [
              {
                from: 0,
                to: 299,
                color: "#f57474", 
              },
              {
                from: 300,
                to: 499,
                color: "#f7da05", 
              },
              {
                from: 500,
                to: 10000,
                color: "#61f393",
              },
            ],
          },
        },
      
      },

      annotations: {
       
        yaxis: [],
      },
   //it is my bottom bar -->
      legend: {
        show: false 
      }
    },
  });

  const labelfuntion = ()=>{
  
    const final_Label_forGraph = Array.isArray(volatilityImpact_firsttable_nonzero) 
    ? volatilityImpact_firsttable_nonzero.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        return key ? key.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2") : "";
      })
    : []
  
    if (final_Label_forGraph.length > 0) {
      setState(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, 
        },
      }));
      setState_1stGraph_flat(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
      setState_3rdGraph(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
      setState_3rdGraph_flat0(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
    }
  }
  useEffect(() => {
    labelfuntion();
  }, [volatilityImpact_firsttable_nonzero]);

  const [state_1stGraph_flat, setState_1stGraph_flat] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "line",
        // background: "#5a2989", // Solid dark background for better contrast
      },
      title: {
        text: ``,
        style: { color: "#686868" },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        theme: "dark",
        y: {
          formatter: function (val, context) {
            // here context is giving us extra info like which series/point we are on.
            const seriesName = context.w.config.series[context.seriesIndex].name;
           
      
            // Optional: Different formatting per series
            if (seriesName.includes("%")) {
              return (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2)) + "%";
            } else {
              return val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
            }
          }
        }
      },
      xaxis: {
        labels: {
          style: { colors: "#686868" },
        },
      },
      yaxis: [
        {
          title: {
            text: "Average Movement (%)",
            style: { color: "#686868" },
          },
          labels: {
            formatter: function (val) {
              return (
                (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) +
                "%"
              );
            },
            style: { colors: "#686868" },
          },
        },
        {
          opposite: true,
          title: {
            text: "Average Movement (points)",
            style: { color: "#686868" },
          },
          labels: {
            formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) ,
            style: { colors: "#686868" },
          },
        
        },
      ],
      stroke: { width: [0, 3 , 3 , 3 , 3] },

      // REMOVE OPACITY FROM BARS
      plotOptions: {
        bar: {
          columnWidth: "24%", // Adjust width if needed
          // borderRadius: 5, // Optional: rounded corners
          colors: {
            ranges: [
              {
                from: 0,
                to: 299,
                color: "#f57474", // Red
              },
              {
                from: 300,
                to: 499,
                color: "#f7da05", // Yellow
              },
              {
                from: 500,
                to: 10000,
                color: "#61f393", // Green
              },
            ],
          },
        },
      },

      annotations: {
        // yaxis: [
        //   {
        //     y: 0,
        //     y2: 300,
        //     fillColor: "#f57474", // Brighter Red
        //     label: { show: false },
        //   },
        //   {
        //     y: 300,
        //     y2: 500,
        //     fillColor: "#f7da05", // Gold Yellow
        //     label: { show: false },
        //   },
        //   {
        //     y: 500,
        //     y2: 10000,
        //     fillColor: "#61f393", // Strong Green
        //     label: { show: false },
        //   },
        // ],
        yaxis: [],
      },
      legend: {
        show: false 
      }
    },
  });
  const [dataCount , setDataCount] = useState(0)
  const [dataCount_flat0 , setDataCount_flat0] = useState(0)
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [noDataAvailable_3rdgraph, setNoDataAvailable_3rdgraph] = useState(false);

  //  <---first graph of non zero event---->

  const graph1_NonFlat = ()=>{
    if (volatilityImpact_firsttable_nonzero.length > 0) {
      setloading_forgraphs(false);
      setMainLoading(false);
      const dataCount = volatilityImpact_firsttable.filter(item => {
        const actualPrevValue = Number(item.actualminusprevious);
        return (
          item.actualminusprevious !== null &&
          item.actualminusprevious !== undefined &&
          item.actualminusprevious !== "" &&
          !isNaN(actualPrevValue) &&
          actualPrevValue !== 0
        );
      });
      // console.log("dataCount" , dataCount)
      const dataCountValue = dataCount.length
      setDataCount(dataCountValue)
          
        const filteredItems = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
            let keyA = Object.keys(a)[0].replace("1min", ""); 
            let keyB = Object.keys(b)[0].replace("1min", "");
            return keyA.localeCompare(keyB);
        });
        // console.log("volatilityImpact_firsttable_nonzero ---> ashima" , volatilityImpact_firsttable_nonzero)

        // console.log("filteredItems" ,filteredItems)

        const valuesArray = filteredItems
        .map(item => {
            let key = Object.keys(item).find(k => k.includes("1min"));
            // console.log("key--->" , key)
            let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
            return isNaN(value) ? 0 : value;
        })
        // .filter(value => !isNaN(value));


        const filteredItems_linegraph = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
            let keyA = Object.keys(a)[0].replace("1min", ""); 
            let keyB = Object.keys(b)[0].replace("1min", "");
            return keyA.localeCompare(keyB);
        });

        const valuesArray_linegraph = filteredItems_linegraph.map(item => {
            let key = Object.keys(item).find(k => k.includes("1min"));
            let value = key ? parseFloat(item[key].highminlow.replace("%", "")) : NaN;
            return isNaN(value) ? 0 : value;
        })
        // console.log("valuesArray_linegraph--->" , valuesArray_linegraph)
        // <---for 2nd , 3rd and 4th line ---->
    //   const valuesArray_linegraph2 = filteredItems_linegraph.map(item => {
    //   let key = Object.keys(item).find(k => k.includes("5min"));
    //   let value = key ? parseFloat(item[key].highminlow.replace("%", "")) : NaN;
    //   return isNaN(value) ? 0 : value;
    // })

    //   const valuesArray_linegraph3 = filteredItems_linegraph.map(item => {
    //     let key = Object.keys(item).find(k => k.includes("15min"));
    //     let value = key ? parseFloat(item[key].highminlow.replace("%", "")) : NaN;
    //     return isNaN(value) ? 0 : value;
    // })

  //   const valuesArray_linegraph4 = filteredItems_linegraph.map(item => {
  //     let key = Object.keys(item).find(k => k.includes("1hr"));
  //     let value = key ? parseFloat(item[key].highminlow.replace("%", "")) : NaN;
  //     return isNaN(value) ? 0 : value;
  // })

  const valuesArray_linegraph2 = [23.8, 26.8, 26.2, 34.2, 33.2, 14.4, 27.8]
  const valuesArray_linegraph3 = [24.8, 25.8, 23.2, 35.2, 32.2, 12.4, 21.8]
  const valuesArray_linegraph4 = [25.8, 25.8, 22.2, 32.2, 38.2, 15.4, 29.8]

      
      // setState((prevState) => {
      //   const updatedSeries = prevState.series.map((series) => {
      //     if (series.name === "Average Movement (%)") {
      //       return { ...series, data: [...valuesArray] };
      //     }
      //     if (series.name === "Average Movement (points)") {
      //       return { ...series, data: [...valuesArray_linegraph] }; 
      //     }
      //     return series;
      //   });

      //   // If "Currency Correlation" or "Average Movement (%)" doesn't exist, add them
      //   if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
      //     updatedSeries.push({
      //       name: "Average Movement (%)",
      //       type: "column",
      //       data: [...valuesArray],
      //     });
      //   }
      //   if (!updatedSeries.find((series) => series.name === "Average Movement (points)")) {
      //     updatedSeries.push({
      //       name: "Average Movement (points)",
      //       type: "line",
      //       data: [...valuesArray_linegraph],
      //     });
      //   }

      //   return { ...prevState, series: updatedSeries };
      // });
      setState((prevState) => {
        const updatedSeries = [
          {
            name: "Average Movement (%)",
            type: "column",
            data: valuesArray,
          },
          {
            name: "Average Movement (points) - 1min",
            type: "line",
            data: valuesArray_linegraph,
          },
          {
            name: "Average Movement (points) - 5min",
            type: "line",
            data: valuesArray_linegraph2,
          },
          {
            name: "Average Movement (points) - 15min",
            type: "line",
            data: valuesArray_linegraph3,
          },
          {
            name: "Average Movement (points) - 1hr",
            type: "line",
            data: valuesArray_linegraph4,
          },
        ];
  
        return { ...prevState, series: updatedSeries };
      });
    }
  }
  useEffect(() => {
    graph1_NonFlat()
  }, [volatilityImpact_firsttable_nonzero]);




  // <----second graph - flat event (of first one)---->
  // useEffect(() => {
  //   if (volatilityImpact_firsttable_zero.length > 0) {
  //     setloading_forgraphs_1stGraph_flat(false);
  //     setMainLoading(false);

  //     const filteredItems = volatilityImpact_firsttable_zero
  //     // .sort((a, b) => {
  //     //     let keyA = Object.keys(a)[0].replace("1min", ""); // Remove "1min"
  //     //     let keyB = Object.keys(b)[0].replace("1min", "");
  //     //     return keyA.localeCompare(keyB);
  //     // });
  //     .sort((a, b) => {
  //       let keyA = Object.keys(a)[0] || ""; 
  //       let keyB = Object.keys(b)[0] || ""; 
  //       return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
  //     });

  //     // const valuesArray = filteredItems.map(item => {
  //     //     let key = Object.keys(item).find(k => k.includes("1min"));
  //     //     return key ? parseFloat(item[key]?.highminlowprevfive.replace("%", "")) : null;
  //     // }).filter(value => !isNaN(value));

  //     const valuesArray = filteredItems.map(item => {
  //       let key = Object.keys(item).find(k => k.includes("1min"));
  //       return key && item[key]?.highminlowprevfive 
  //         ? parseFloat(item[key].highminlowprevfive.replace("%", "")) 
  //         : null;
  //     }).filter(value => value !== null && !isNaN(value));  // ✅ Ensure valid numbers only
      

  //     const filteredItems_linegraph = volatilityImpact_firsttable_zero
  //     .sort((a, b) => {
  //         let keyA = Object.keys(a)[0].replace("1min", ""); // Remove "1min"
  //         let keyB = Object.keys(b)[0].replace("1min", "");
  //         return keyA.localeCompare(keyB);
  //     });

  //     const valuesArray_linegraph = filteredItems_linegraph.map(item => {
  //         let key = Object.keys(item).find(k => k.includes("1min"));
  //         return key ? parseFloat(item[key].highminlow.replace("%", "")) : null;
  //     }).filter(value => !isNaN(value));

  //     setState_1stGraph_flat((prevState) => {
  //       const updatedSeries = prevState.series.map((series) => {
  //         if (series.name === "Currency Correlation") {
  //           return { ...series, data: [...valuesArray] };
  //         }
  //         if (series.name === "Average Movement (%)") {
  //           return { ...series, data: [...valuesArray_linegraph] }; // **Force new array to ensure re-render**
  //         }
  //         return series;
  //       });

  //       // If "Currency Correlation" or "Average Movement (%)" doesn't exist, add them
  //       if (!updatedSeries.find((series) => series.name === "Currency Correlation")) {
  //         updatedSeries.push({
  //           name: "Currency Correlation",
  //           type: "column",
  //           data: [...valuesArray],
  //         });
  //       }
  //       if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
  //         updatedSeries.push({
  //           name: "Average Movement (%)",
  //           type: "line",
  //           data: [...valuesArray_linegraph],
  //         });
  //       }

  //       return { ...prevState, series: updatedSeries };
  //     });
  //   }
  // }, [volatilityImpact_firsttable_zero]);
  const graph2_Flat = ()=>{
    if (volatilityImpact_firsttable_zero.length > 0) {
      setloading_forgraphs_1stGraph_flat(false);
      setMainLoading(false);
      // console.log("volatilityImpact_firsttable_zero" , volatilityImpact_firsttable_zero)

      const dataCount = volatilityImpact_firsttable.filter(item => {
        const actualPrevValue = Number(item.actualminusprevious);
        return (
          item.actualminusprevious !== null &&
          item.actualminusprevious !== undefined &&
          item.actualminusprevious !== "" &&
          !isNaN(actualPrevValue) &&
          actualPrevValue === 0
        );
      });
      // console.log("dataCount" , dataCount)
      const dataCountValue = dataCount.length
      // console.log("dataCountValue---" , dataCountValue)
      setDataCount_flat0(dataCountValue)
      const filteredItems = volatilityImpact_firsttable_zero
        .filter(item => Object.keys(item).length > 0) 
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || ""; 
          let keyB = Object.keys(b)[0] || ""; 
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });
  
      const valuesArray = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key && item[key]?.highminlowprevfive 
          ? parseFloat(item[key].highminlowprevfive.replace("%", "")) 
          : NaN;
          return isNaN(value) ? 0 : value;
      })
      // .filter(value => value !== null && !isNaN(value));  
  
      const valuesArray_linegraph = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key && item[key]?.highminlow 
          ? parseFloat(item[key].highminlow.replace("%", "")) 
          : NaN;
          return isNaN(value) ? 0 : value;
      })

      const valuesArray_linegraph2 = [23.8, 26.8, 26.2, 34.2, 33.2, 14.4, 27.8]
      const valuesArray_linegraph3 = [24.8, 25.8, 23.2, 35.2, 32.2, 12.4, 21.8]
      const valuesArray_linegraph4 = [25.8, 25.8, 22.2, 32.2, 38.2, 15.4, 29.8]
    
      // .filter(value => value !== null && !isNaN(value));
     
      if (valuesArray.length === 0 || valuesArray.every(value => value === 0)) {
        setNoDataAvailable(true);
        // console.log("hi am here");
        return;
      } else {
        setNoDataAvailable(false);
        // console.log("hi am here in false");
      }
      setState_1stGraph_flat((prevState) => {
        const updatedSeries = prevState.series.map((series) => {
          if (series.name === "Average Movement (%)") {
            return { ...series, data: [...valuesArray] };
          }
          if (series.name === "Average Movement (points)") {
            return { ...series, data: [...valuesArray_linegraph] };
          }
          return series;
        });
  
        if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
          updatedSeries.push({ name: "Average Movement (%)", type: "column", data: [...valuesArray] });
        }
        if (!updatedSeries.find((series) => series.name === "Average Movement (points)")) {
          updatedSeries.push({ name: "Average Movement (points)", type: "line", data: [...valuesArray_linegraph] });
        }
  
        return { ...prevState, series: updatedSeries };
      });


      setState_1stGraph_flat((prevState)=>{
        const updatedSeries = [
          {
            name: "Average Movement (%)",
            type: "column",
            data: valuesArray,
          },
          {
            name: "Average Movement (points) - 1min",
            type: "line",
            data: valuesArray_linegraph,
          },
          {
            name: "Average Movement (points) - 5min",
            type: "line",
            data: valuesArray_linegraph2,
          },
          {
            name: "Average Movement (points) - 15min",
            type: "line",
            data: valuesArray_linegraph3,
          },
          {
            name: "Average Movement (points) - 1hr",
            type: "line",
            data: valuesArray_linegraph4,
          },
        ];
        return {...prevState , series : updatedSeries}
      })
    }
  }

 
  useEffect(() => {
    graph2_Flat();
  }, [volatilityImpact_firsttable_zero]); 
  
  // <------second row graph means third graph----->
// kapil=------------------------------


  // const [state_3rdGraph, setState_3rdGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: { height: 350, type: "line" },
  //     stroke: { width: [0, 4] },
  //     title: { text: `` },
  //     dataLabels: { enabled: true, enabledOnSeries: [1] },
  //     labels: [
  //       "01 Jan 2001",
  //       "02 Jan 2001",
  //       "03 Jan 2001",
  //       "04 Jan 2001",
  //       "05 Jan 2001",
  //       "06 Jan 2001",
  //       "07 Jan 2001",
  //     ],
  //     yaxis: [
  //       { title: { text: "Currency Correlation" } },
  //       { opposite: true, title: { text: "Average Movement (%)" } },
  //     ],
  //   },
  // });

  // const [state_4thGraph, setState_4thGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: {
  //       height: 350,
  //       type: "bar",
  //       stacked: true, // Enable stacking globally
  //     },
  //     title: {
  //       text: "Stacked Column Chart",
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false, // Ensure vertical stacking
  //         columnWidth: "60%", // Adjust width if needed
  //         endingShape: "rounded",
  //         dataLabels: {
  //           total: {
  //             enabled: true,
  //             formatter: (val) => val.toFixed(2),
  //           },
  //         },
  //         stackType: "100%", // Enable stacking inside plotOptions
  //       },
  //     },
  //     yaxis: [
  //       {
  //         title: {
  //           text: "Stacked Values",
  //         },
  //       },
  //       {
  //         opposite: true,
  //         title: {
  //           text: "Percentage (%)",
  //         },
  //         // min: 0,
  //         // max: 100,
  //         // tickAmount: 5,
  //       },
  //     ],
  //     xaxis: {
  //       categories: ["1", "2", "3", "4", "5", "6", "7"], // Adjust categories as needed
  //     },
  //   },
  // });

  // <---working code till now ------->

  // const [state_4thGraph, setState_4thGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: {
  //       height: 500, // Increase height for better visibility
  //       type: "bar",
  //       stacked: true, // Keep stacking enabled
  //       yAxisIndex: 0,
  //     },
  //     title: {
  //       text: "Stacked Column Chart",
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "60%",
  //         endingShape: "rounded",
  //         dataLabels: {
  //           total: {
  //             enabled: true,
  //             formatter: (val) => val.toFixed(2),
  //           },
  //         },
  //       },
  //     },
  //     yaxis: [
  //       {
  //         title: { text: "Column Values (%)" },
  //         labels: {
  //           formatter: (val) => val.toFixed(2),
  //         },
  //         min: 0,
  //         max: undefined,
  //       },
  //       {
  //         opposite: true,
  //         title: { text: "Percentage (%)" },
  //         labels: {
  //           formatter: (val) => val.toFixed(2),
  //         },
  //       },
  //     ],
  //     xaxis: {
  //       categories: ["1", "2", "3", "4", "5", "6", "7"],
  //     },
  //   },
  // });


  const [state_3rdGraph, setState_3rdGraph] = useState({
    series: [
      { name: "Currency Correlation", type: "rangeBar", data: [] },
      { name: "Average Movement (%)", type: "line", data: [] },
    ],
    options: {
      // chart: { height: 350, type: "line"},
      stroke: { width: [0, 4] }, // Column: 0 width, Line: 4 width
      fill: {
        opacity: [1, 1], // full opacity for both series
      },
      
      title: { text: `of ${event || ""}`, style: { color: "#ffffff" } },
      dataLabels: { enabled: true, enabledOnSeries: [1] }, // Labels only for line graph
      tooltip: { theme: "dark" },
      xaxis: {
        labels: { style: { colors: "#686868" } }, // ✅ X-axis text white
      },
      yaxis: [
        {
          title: { text: "Currency Correlation", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } ,
          formatter: (value) => `${value}%`, 
        }, // ✅ Y-axis text white
        },
        {
          opposite: true,
          title: { text: "Average Movement (%)", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } }, // ✅ Y-axis text white
        },
      ],
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },
      plotOptions: { bar: { distributed: true } }, // Enables different colors for bars
    },
  });
    const [state_3rdGraph_flat0, setState_3rdGraph_flat0] = useState({
    series: [
      { name: "Currency Correlation", type: "column", data: [] },
      { name: "Average Movement (%)", type: "line", data: [] },
    ],
    options: {
      chart: { height: 350, type: "line"},
      stroke: { width: [0, 4] }, // Column: 0 width, Line: 4 width
      title: { text: `of ${event || ""}`, style: { color: "#ffffff" } },
      dataLabels: { enabled: true, enabledOnSeries: [1] }, // Labels only for line graph
      tooltip: { theme: "dark" },
      xaxis: {
        labels: { style: { colors: "#686868" } }, // ✅ X-axis text white
      },
      yaxis: [
        {
          title: { text: "Currency Correlation", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } ,
          formatter: (value) => `${value}%`, 
        }, // ✅ Y-axis text white
        },
        {
          opposite: true,
          title: { text: "Average Movement (%)", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } }, // ✅ Y-axis text white
        },
      ],
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },
      plotOptions: { bar: { distributed: true } }, // Enables different colors for bars
    },
  });
  
  // /,----it is also working but -100 , +100 issue coming---->
  const [chartData, setChartData] = useState([]);
  const [chartData_flat0, setChartData_flat0] = useState([]);

  // <--for third graph and 4th graph--->
  const [chartData3, setChartData3] = useState([]);
  const [chartData3_flat0, setChartData3_flat0] = useState([]);

  
// <--third graph NON FLAT--->

  const graph3_NonFlat = () =>{
    if (volatilityImpact_secondtable_flatPOS_flatNEV.length > 0) {
      setloading_forgraphs_3rdgraph(false);
    
        const filteredItems = volatilityImpact_secondtable_flatPOS_flatNEV
        .filter(item => Object.keys(item).length > 0)
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || "";
          let keyB = Object.keys(b)[0] || "";
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });

      const valuesArray_forarea1 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value =  key ? parseFloat(item[key].closeminusopennonZeroPositive) : NaN;
        return isNaN(value) ? 0 : value;
      })
      const valuesArray2 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value =  key ? parseFloat(item[key].closeminusopennonZeroNegative) : NaN;
        return isNaN(value) ? 0 : -Math.abs(value);;
      })

    const valuesArray_forarea1_2ndcandle = [60, 35, 75, 45, 55, 60, 70]
    const valuesArray2__2ndcandle = [-40, -25, -65, -45, -35, -60, -40]
    

  
    const valuesArray_forarea1_3rdcandle = [50, 99, 65, 75, 35, 60, 30]
    const valuesArray2__3rdcandle = [-40, -55, -85, -15, -45, -90, -10]


    const valuesArray_forarea1_4thcandle = [86, 85, 75, 95, 55, 30, 70]
    const valuesArray2__4thcandle = [-40, -65, -65, -45, -75, -20, -60]


    const columndata  = [valuesArray_forarea1 , valuesArray2]
    const columndata2 = [valuesArray_forarea1_2ndcandle , valuesArray2__2ndcandle]
    const columndata3 = [valuesArray_forarea1_3rdcandle , valuesArray2__3rdcandle]
    const columndata4 = [valuesArray_forarea1_4thcandle , valuesArray2__4thcandle]

        const columndata_forLables = volatilityImpact_secondtable_flatPOS_flatNEV.map(item => {
          // Get and sort keys that end with "1minprevfive"
          let keys = Object.keys(item)
            .filter(k => k.endsWith("1min"))
            .map(k => k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
            .sort((a, b) => a.localeCompare(b));
        
          // console.log("Formatted Keys:", keys); // Check output
        
          return keys;
        });
        
        const values_forline = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
    
      const newData = valuesArray_forarea1.map((value, index) => {
        const level0 = columndata[0]?.[index] ?? 0;
        const level1 = columndata[1]?.[index] ?? 0;
        
        // <--2nd--->
        const level0_2 = columndata2[0]?.[index] ?? 0;
        const level1_2 = columndata2[1]?.[index] ?? 0;

        // <--3rd--->
        const level0_3 = columndata3[0]?.[index] ?? 0;
        const level1_3 = columndata3[1]?.[index] ?? 0;


        // <--4th--->

        const level0_4 = columndata4[0]?.[index] ?? 0;
        const level1_4 = columndata4[1]?.[index] ?? 0;

        const maxAbs = Math.max(Math.abs(level0), Math.abs(level1));
        const maxAbs2 = Math.max(Math.abs(level0_2), Math.abs(level1_2));
        const maxAbs3 = Math.max(Math.abs(level0_3), Math.abs(level1_3));
        const maxAbs4 = Math.max(Math.abs(level0_4), Math.abs(level1_4));
        
        
        let fillColor = "#f68989"; // Red by default
        if (maxAbs > 80) fillColor = "#61f393";    
        else if (maxAbs > 65 && maxAbs <= 80) fillColor = "#f7da05"; 
      
        let fillColor2 = "#f68989"; 
        if (maxAbs2 > 80) fillColor2 = "#61f393";    
        else if (maxAbs2 > 65 && maxAbs2 <= 80) fillColor2 = "#f7da05";
      
        let fillColor3 = "#f68989"; 
        if (maxAbs3 > 80) fillColor3 = "#61f393";    
        else if (maxAbs3 > 65 && maxAbs3 <= 80) fillColor3 = "#f7da05";

        let fillColor4 = "#f68989"; 
        if (maxAbs4 > 80) fillColor4 = "#61f393";    
        else if (maxAbs4 > 65 && maxAbs4 <= 80) fillColor4 = "#f7da05";
        //built-in JavaScript method that converts a Unicode number- string.fromcharcode....
        return {
          name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`,
          Onemin_Positive: level0,
          Onemin_Negative: level1,
          
          Fivemin_Positive: level0_2,
          Fivemin_Negative: level1_2,

          Fifteenmin_Positive: level0_3,
          Fifteenmin_Negative: level1_3,
          
          Onehour_Positive: level0_4,
          Onehour_Negative: level1_4,

          fillColor,
          fillColor2 ,
          fillColor3 ,
          fillColor4 ,

          MovementAvgPercentage: values_forline[index]
        };
      });
      

      console.log("newData ashima---->", newData);
      setChartData3(newData);
    }
  }
  useEffect(() => {
    graph3_NonFlat();
  }, [volatilityImpact_firsttable_nonzero , volatilityImpact_secondtable_flatPOS_flatNEV]);


// <----3rd graph ---->
// <----flat third graph --->

  const graph3_Flat = ()=>{
    if (volatilityImpact_secondtable_flatPOS_flatNEV.length > 0) {
      setloading_forgraphs_3rdGraph_flat0(false);
     
        const filteredItems = volatilityImpact_secondtable_flatPOS_flatNEV
        .filter(item => Object.keys(item).length > 0)
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || "";
          let keyB = Object.keys(b)[0] || "";
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });
  
      const valuesArray_forarea1 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value =  key ? parseFloat(item[key].closeminusopennonFlatPostive) : NaN;
        return isNaN(value) ? 0 : value;
      })
      const valuesArray2 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value =  key ? parseFloat(item[key].closeminusopennonFlatNegative) : NaN;
        return isNaN(value) ? 0 : -Math.abs(value);;
      })
      const valuesArray_forarea1_2ndcandle = [20, 35, 75, 45, 55, 60, 70]
      const valuesArray2__2ndcandle = [-40, -25, -65, -45, -35, -60, -40]
     
      const columndata = [valuesArray_forarea1 , valuesArray2]
      const columndata2 = [valuesArray_forarea1_2ndcandle , valuesArray2__2ndcandle]
        // console.log("columndata" , columndata)
  
        const columndata_forLables = volatilityImpact_secondtable_flatPOS_flatNEV.map(item => {
          // Get and sort keys that end with "1minprevfive"
          let keys = Object.keys(item)
            .filter(k => k.endsWith("1min"))
            .map(k => k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
            .sort((a, b) => a.localeCompare(b));
        
          // console.log("Formatted Keys:", keys); // Check output
        
          return keys;
        });
        
        const values_forline = volatilityImpact_firsttable_zero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
        const newData = valuesArray_forarea1.map((value, index) => {
          const level0 = columndata[0]?.[index] ?? 0;
          const level1 = columndata[1]?.[index] ?? 0;
          
          const level0_2 = columndata2[0]?.[index] ?? 0;
          const level1_2 = columndata2[1]?.[index] ?? 0;

          const maxAbs = Math.max(Math.abs(level0), Math.abs(level1));
          const maxAbs2 = Math.max(Math.abs(level0_2), Math.abs(level1_2));
          let fillColor = "#f68989"; // Red by default
          if (maxAbs > 80) fillColor = "#61f393";     // Green
          else if (maxAbs > 65 && maxAbs <= 80) fillColor = "#f7da05"; // Yellow
        
          let fillColor2 = "#f68989"; 
          if (maxAbs2 > 80) fillColor2 = "#61f393";    
          else if (maxAbs2 > 65 && maxAbs2 <= 80) fillColor2 = "#f7da05";

          return {
            name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`,
            Level0: level0,
            Level1: level1,
            Level0_2: level0_2,
            Level1_2: level1_2,
            fillColor,
            fillColor2 ,
            MovementAvgPercentage: values_forline[index]
          };
        });
        
      setChartData3_flat0(newData);
    }
  }
  useEffect(() => {
    graph3_Flat();
  }, [ volatilityImpact_secondtable_flatPOS_flatNEV]);



    // <--forth graph--->
    useEffect(() => {
      if (volatilityImpact_firsttable_nonzero.length > 0) {
        setloading_forgraphs_4thgraph(false);
        const lineData = [89, 76, 65, 200, 588, 322, 700];
    
        let valuesArray_forarea1 = volatilityImpact_firsttable_nonzero
          .sort((a, b) => {
            let keyA = Object.keys(a)[0].replace("1min", "");
            let keyB = Object.keys(b)[0].replace("1min", "");
            return keyA.localeCompare(keyB);
          })
          .map(item => {
            let key = Object.keys(item).find(k => k.includes("1min"));
            let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
            return isNaN(value) ? 0 : value;
          })
          // .filter(value => !isNaN(value));
        
        
          const columndata = volatilityImpact_firsttable
          .filter(item => {
            const actualPrevValue = Number(item.actualminusprevious);
            return (
              item.actualminusprevious !== null &&
              item.actualminusprevious !== undefined &&
              item.actualminusprevious !== "" &&
              !isNaN(actualPrevValue) &&
              actualPrevValue !== 0
            );
          })
          .map(item => {
            // Get and sort keys that end with "1minprevfive"
            let keys = Object.keys(item)
              .filter(k => k.endsWith("1minprevfive"))
              .sort((a, b) => a.localeCompare(b)); 
          
            // console.log("Sorted Keys:", keys);
          
            // Extract values based on sorted keys
            return keys
              .map(key => {
                let highlowValue = item[key]?.[0]?.highlow;
                let value = highlowValue ? parseFloat(highlowValue.replace("%", "")) : NaN;
                return isNaN(value) ? 0 : value;
              })
              // .filter(value => value !== null); 
          });
          // console.log("4th graph column data" , columndata)

          

          const columndata_forLables = volatilityImpact_firsttable.map(item => {
            // Get and sort keys that end with "1minprevfive"
            let keys = Object.keys(item)
              .filter(k => k.endsWith("1minprevfive"))
              .map(k => k.replace("1minprevfive", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
              .sort((a, b) => a.localeCompare(b));
          
            // console.log("Formatted Keys:", keys); // Check output
          
            return keys;
          });
          
          
          // console.log("valuesArray_forarea1", valuesArray_forarea1);
          
        const newData = valuesArray_forarea1.map((value, index) => ({
          // name: `Page ${String.fromCharCode(65 + index)}`,
          name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`, 
          Level0: columndata[0]?.[index] ?? null,
          Level1: columndata[1]?.[index] ?? null,
          Level2: columndata[2]?.[index] ?? null,
          Level3: columndata[3]?.[index] ?? null,
          Level4: columndata[4]?.[index] ?? null,
          Level5: columndata[5]?.[index] ?? null,
          Level6: columndata[6]?.[index] ?? null,
          MovementAvgPercentage: value,
          // variance: lineData[index] 
        }));
    
        // console.log("newData", newData);
        setChartData(newData);
      }
    }, [volatilityImpact_firsttable_nonzero , volatilityImpact_firsttable]);
    

    // <------forth graph flat values -0---->
    useEffect(() => {
      if (volatilityImpact_firsttable_nonzero.length > 0) {
        setloading_forgraphs_4thgraph_flat0(false);
        const lineData = [89, 76, 65, 200, 588, 322, 700];
    
        let valuesArray_forarea1 = volatilityImpact_firsttable_zero
          .sort((a, b) => {
            let keyA = Object.keys(a)[0].replace("1min", "");
            let keyB = Object.keys(b)[0].replace("1min", "");
            return keyA.localeCompare(keyB);
          })
          .map(item => {
            let key = Object.keys(item).find(k => k.includes("1min"));
            let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
            return isNaN(value) ? 0 : value;
          })
          // .filter(value => !isNaN(value));
        
        
          const columndata = volatilityImpact_firsttable
          .filter(item => {
            const actualPrevValue = Number(item.actualminusprevious);
            return (
              item.actualminusprevious !== null &&
              item.actualminusprevious !== undefined &&
              item.actualminusprevious !== "" &&
              !isNaN(actualPrevValue) &&
              actualPrevValue === 0
            );
          })
          .map(item => {
            // Get and sort keys that end with "1minprevfive"
            let keys = Object.keys(item)
              .filter(k => k.endsWith("1minprevfive"))
              .sort((a, b) => a.localeCompare(b)); 
          
            // console.log("Sorted Keys:", keys);
          
            // Extract values based on sorted keys
            return keys
              .map(key => {
                let highlowValue = item[key]?.[0]?.highlow;
                let value = highlowValue ? parseFloat(highlowValue.replace("%", "")) : NaN;
                return isNaN(value) ? 0 : value;
              })
              // .filter(value => value !== null); // Remove null values
          });
          
          // console.log("item" , columndata)

          const columndata_forLables = volatilityImpact_firsttable.map(item => {
            // Get and sort keys that end with "1minprevfive"
            let keys = Object.keys(item)
              .filter(k => k.endsWith("1minprevfive"))
              .map(k => k.replace("1minprevfive", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
              .sort((a, b) => a.localeCompare(b));
          
            // console.log("Formatted Keys:", keys); // Check output
          
            return keys;
          });
          
          
          // console.log("valuesArray_forarea1", valuesArray_forarea1);
          
        const newData = valuesArray_forarea1.map((value, index) => ({
          // name: `Page ${String.fromCharCode(65 + index)}`,
          name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`, 
          Level0: columndata[0]?.[index] ?? null,
          Level1: columndata[1]?.[index] ?? null,
          Level2: columndata[2]?.[index] ?? null,
          Level3: columndata[3]?.[index] ?? null,
          Level4: columndata[4]?.[index] ?? null,
          Level5: columndata[5]?.[index] ?? null,
          Level6: columndata[6]?.[index] ?? null,
          MovementAvgPercentage: value,
          // variance: lineData[index] 
        }));
    
        // console.log("newData", newData);
        setChartData_flat0(newData);
      }
    }, [volatilityImpact_firsttable_zero , volatilityImpact_firsttable]);
    
       
      useEffect(() => {
        document.body.style.backgroundColor = "#d2c2f070";
        return () => {
          document.body.style.backgroundColor = ""; 
        };
      }, []);

      const handleCheckboxChange = (value) => {
        setSelectedEventTypes((prev) =>
          prev.includes(value)
            ? prev.filter((item) => item !== value)
            : [...prev, value]
        );
      };
    //   const handleGenerateTables = () => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
    //     const eventtime = decodeURIComponent(urlParams.get("eventtime"));
    //     const eventdate = decodeURIComponent(urlParams.get("eventdate"));
    //     const eventId = decodeURIComponent(urlParams.get("eventId"));
    //     const url = new URL(window.location.origin + "/user/eventshistory_trial");
    //     url.searchParams.set("eventName", event);
    //     url.searchParams.set("eventcountry", country);
    //     url.searchParams.set("eventimpact", eventimpact);
    //     url.searchParams.set("eventtime", eventtime);
    //     url.searchParams.set("eventdate", eventdate);
    //     url.searchParams.set("eventId", eventId);
    
    //     const newTab = window.open(url.toString(), "_blank");
    //   };
    
    return (
    <>
    <div className=" ">
      <p className="font-semiBold text-[#000] m-[1%]">Here are the Visualisation ComparePage charts of 
      <span className="ml-1 font-bold">  {event}  {country? `(${country})` : ""}</span> :-
      </p>
      {
        MainLoading ? 
        <>
        <div className="">
          <div className="font-semibold m-6 font-xl text-center flex justify-center items-center">
            Wait for charts .....
          </div>
    
          <div className="loader-container w-full flex justify-center ">
            
            <img
            src={loader_video}
            title="loader"
            alt="loader"
            className="w-[300px] h-[300px]"
            // width={500}
            // height={600}
            autoPlay
            loop
            muted
        />

          </div>  
        {/* </div> */}

        </div>
        </> : 
        <>
        <div className="flex justify-between items-center w-full mt-[2%] ">
        <IoArrowBack
        className=" cursor-pointer  ml-5 "
        onClick={() => navigate("/user/economicdata")}
        title="Back Button"
        />

         {/* <--show underline data button---> */}
         <div className="flex justify-end">
         <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
         <div className="p-4 flex justify-end items-center ">
       <div className="flex justify-center items-center">
       <h3 className="mb-2 font-semibold mr-3">Select Event Times:</h3>

      {allOptions.map((type) => (
      <label key={type} className="block mb-1">
        <input
          type="checkbox"
          value={type}
          checked={selectedEventTypes.includes(type)}
          onChange={() => handleCheckboxChange(type)}
        />
        <span className="ml-2">{type}</span>
      </label>
      ))}
       </div>

      <button
        onClick={getFirstTabledata}
        className=" px-4 py-2 bg-[#240D3A] text-white rounded-[8px] ml-5"
      >
        Save & Fetch
      </button>
     </div>
      <div>
      <Space
        style={{
          width: "100%",
          paddingTop: 0,
          height: "46px",
        }}
        direction="vertical"
      >
        <FormControl sx={{ width: 200, height: 46 }}>
          <InputLabel id="range-select-label">
            Select Range
          </InputLabel>
          <Select
            labelId="range-select-label"
              label="Events Range"
            value={eventRange}
            defaultValue="6"
            onChange={(e) => handleOptionChange(e.target.value)}
            
            sx={{ height: 46 }}
          >
            <MenuItem value="6">Last 6</MenuItem>
            <MenuItem value="12">Last 12</MenuItem>
            <MenuItem value="24">Last 24</MenuItem>
          </Select>
        </FormControl>
      </Space>
      </div>
        </div>
        {/* <div className={`h-[40px] p-3 justify-center text-[#240d3a] font-small text-[14px] flex border border-solid border-[#240d3a] items-center rounded-md mr-5 cursor-pointer `}
          onClick={
            handleGenerateTables}>
            <img
            src={tableicon}
            alt="tableicon"
            className="h-[20px] w-[20px] mr-2  "
            title="See Tables"  />

          <h1 className="">Show underline data</h1>
        </div> */}
        </div>

        


        </div>
       
        <div className="flex w-full items-center mt-2 justify-center mb-3 flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-col">
          <div className="w-full items-center flex flex-col">
          <h1 className="font-bold text-[18px]">Non- Zero event</h1>
          {/* <--first column non flat graphs all----> */}
          <div className="flex justify-around items-center flex-row w-[98%] border-4 px-2 py-4 border-[#D2C2F0] ">
          <div id="chart" className="w-[42%] ">
            {loading_forgraphs ? (
              <p>loading.... </p>
            ) : (
              <>
              <div className="border rounded-md bg-[#fff] p-5 h-[530px]">
               <div className="flex justify-end items-center w-full">
               <div className="flex justify-start items-center m-4 border border-solid border-[#240d3a] w-[124px]">
                <p className="p-1 text-[13px]">Data Count : {dataCount}</p>
              
                </div>
               </div>
                <ReactApexChart
                  options={state.options}  //label , color , tooltip
                  series={state.series} //actual data
                  type="line"
                  height={350}
                />
                <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={baricon}
                alt="columnBars"
              
                className="h-[20px] w-[20px] "
                title="Column Bars"
                />
                  <h1 className="w-[195px]">Average Movement (%) : </h1>
                <div className="w-[55.03px]"><span style={{ background: '#f57474' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>0–299</div>
                <div className="w-[71.03px]"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>300–500</div>
                <div className="w-[51.66px]"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span> 500+</div>
                </div>
                <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                  <h1 className="w-[195px]">Average Movement (points) : </h1>
                <div className="">1min<span style={{ background: '#26e7a6' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">5min<span style={{ background: '#febc3b' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">15min<span style={{ background: '#fd5e76' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">1hr<span style={{ background: '#8a60c2' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                </div>
                {/* <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                  <h1 className="w-[195px]">Average Movement (points) - 5min : </h1>
                  <div className="w-[55.03px]"><span style={{ background: '#febc3b' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[71.03px] invisible"><span style={{ background: '#f7da05' }} className=" w-3 h-3 rounded-full mr-1 "></span>300–500</div>
                <div className="w-[51.66px] invisible"><span style={{ background: '#61f393' }} className=" w-3 h-3 rounded-full mr-1"></span> 500+</div>
               
                </div> */}
                {/* <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                  <h1 className="w-[195px]">Average Movement (points) - 15min : </h1>
                  <div className="w-[55.03px]"><span style={{ background: '#fd5e76' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[71.03px] invisible"><span style={{ background: '#f7da05' }} className=" w-3 h-3 rounded-full mr-1 "></span>300–500</div>
                <div className="w-[51.66px] invisible"><span style={{ background: '#61f393' }} className=" w-3 h-3 rounded-full mr-1"></span> 500+</div>
               
                </div> */}
                {/* <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                  <h1 className="w-[195px]">Average Movement (points) - 1hr: </h1>
                  <div className="w-[55.03px]"><span style={{ background: '#8a60c2' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[71.03px] invisible"><span style={{ background: '#f7da05' }} className=" w-3 h-3 rounded-full mr-1 "></span>300–500</div>
                <div className="w-[51.66px] invisible"><span style={{ background: '#61f393' }} className=" w-3 h-3 rounded-full mr-1"></span> 500+</div>
               
                </div> */}

                </div>
              </>
            )}
          </div>
          <div id="chart" className="w-[54%] ">
            {loading_forgraphs_3rdgraph ? (
              <p>loading.... </p>
            )  
            : (
              <>
              <div className=" rounded-md bg-[#fff] p-5 h-[530px]">
              <div className="flex justify-end items-center w-full">
               <div className="flex justify-start items-center m-4 border border-solid border-[#240d3a] w-[124px]">
                <p className="p-1 text-[13px]">Data Count : {dataCount}</p>
              
                </div>
               </div>
              <div style={{ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "12px" ,  color: "black" }} className=" rounded-md bg-[#fff] p-5 text-black">

              <ResponsiveContainer width="100%" height={365} >
              <ComposedChart data={chartData3}  barCategoryGap={40} barGap={-8}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
               

                <YAxis
                    yAxisId="left"
                    tickFormatter={(value) => `${value} %`}
                    label={{
                      value: "Currency correlation (%)",
                      angle: -90,
                      position: "insideLeft",
                      style: { fill: "#686868" },
                      dy: 90 
                    }}
                  />

                  <YAxis
                    yAxisId="right"
                    orientation="right"
                    label={{
                      value: "Average Movement (%) ",
                      angle: 90,
                      position: "insideRight",
                      style: { fill: "#686868" },
                      dy: 90 // adjust this too
                    }}
                  />
                <Tooltip />
                <ReferenceLine
                  y={0}
                  yAxisId="left"
                  stroke="black"
                  // strokeWidth={2}
                  // strokeDasharray="5 5"
                  label={{
                    value: "",
                    position: "insideTopLeft",
                    fill: "black",
                    fontSize: 14,
                    fontWeight: "bold"
                  }}
                />


                {/* <Legend /> */}
               

                
                {/* Sketched Column Bars */}
                {/* <Bar dataKey="Level0" stackId="positive" barSize={20}  yAxisId="left" fill="#f57474"/>
                <Bar dataKey="Level1" stackId="negative" barSize={20}  yAxisId="left" fill="#f57474"/> */}
               
               {/* <--first candle---> */}
                <Bar dataKey="Onemin_Positive" stackId="Onemin_Positive" barSize={20} yAxisId="left" 
                shape={(props) => {
                  const { x, y, width, height, fill } = props;
                  const textOffset = 12;
                  return (
                    // <rect
                    //    x={x + 12} // shift it manually
                    //   y={y}
                    //   width={width}
                    //   height={height}
                    //   fill={fill}
                    // />
                    <g>
                    <rect
                      x={x + 12} // Shift it manually
                      y={y}
                      width={width}
                      height={height}
                      fill={fill}
                    />
                    {/* Add text inside the candlestick */}
                    <text
                      x={x + width / 2 + textOffset } // Position the text in the center of the bar
                      y={y + height / 2 + textOffset} // Position the text vertically centered
                      fill="#000" // Text color
                      fontSize={12}
                      textAnchor="middle" // Center the text horizontally
                      alignmentBaseline="middle" // Center vertically
                      transform={`rotate(270, ${x + width / 2}, ${y + height / 2})`}
                    >
                      1min
                    </text>
                  </g>
                  );
                }}>
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level0-${index}`} fill={entry.fillColor} />
                  ))}
                </Bar>

             
                <Bar dataKey="Onemin_Negative" stackId="Onemin_Negative" barSize={20} yAxisId="left">
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level1-${index}`} fill={entry.fillColor} />
                  ))}

                </Bar>

                 {/* <--second candle---> */}
                <Bar dataKey="Fivemin_Positive" stackId="Fivemin_Positive" barSize={20} yAxisId="left" style={{ marginLeft: '20px' }} className="ashi" shape={(props) => {
                  const { x, y, width, height, fill } = props;
                  const textOffset = 10;
                  return (
                    <>
                    <rect
                       x={x + 12} // shift it manually
                      y={y}
                      width={width}
                      height={height}
                      fill={fill}
                    />
                    <text
                    x={x + width / 2 + textOffset } // Position the text in the center of the bar
                    y={y + height / 2 + textOffset} // Position the text vertically centered
                    fill="#000" // Text color
                    fontSize={12}
                    textAnchor="middle" // Center the text horizontally
                    alignmentBaseline="middle" // Center vertically
                    transform={`rotate(270, ${x + width / 2}, ${y + height / 2})`}
                  >
                    5 min
                  </text>
                  </>
                  );
                }}>
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level0-2-${index}`} fill={entry.fillColor2}  style={{ marginLeft: '20px' }} className="ashima" />
                  ))}
                </Bar>

                <Bar dataKey="Fivemin_Negative" stackId="Fivemin_Negative" barSize={20} yAxisId="left">
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level1-2-${index}`} fill={entry.fillColor2} />
                  ))}
                </Bar>


                {/* <--third candle---> */}
                <Bar dataKey="Fifteenmin_Positive" stackId="Fifteenmin_Positive" barSize={20} yAxisId="left" shape={(props) => {
                  const { x, y, width, height, fill } = props;
                  const textOffset = 10;
                  return (
                    <>
                    <rect
                       x={x + 12} // shift it manually
                      y={y}
                      width={width}
                      height={height}
                      fill={fill}
                    />
                     <text
                      x={x + width / 2 + textOffset } // Position the text in the center of the bar
                      y={y + height / 2 + textOffset} // Position the text vertically centered
                      fill="#000" // Text color
                      fontSize={12}
                      textAnchor="middle" // Center the text horizontally
                      alignmentBaseline="middle" // Center vertically
                      transform={`rotate(270, ${x + width / 2}, ${y + height / 2})`}
                    >
                      15 min
                    </text>
                    </>
                  );
                }}>
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level0-3-${index}`} fill={entry.fillColor3} />
                  ))}
                </Bar>

                <Bar dataKey="Fifteenmin_Negative" stackId="Fifteenmin_Negative" barSize={20} yAxisId="left">
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level1-3-${index}`} fill={entry.fillColor3} />
                  ))}
                </Bar>


                {/* <--forth candle---> */}
                <Bar dataKey="Onehour_Positive" stackId="Onehour_Positive" barSize={20} yAxisId="left" shape={(props) => {
                  const { x, y, width, height, fill } = props;
                  const textOffset = 10;
                  return (
                    <>
                    <rect
                       x={x + 12} // shift it manually
                      y={y}
                      width={width}
                      height={height}
                      fill={fill}
                    />
                     <text
                      x={x + width / 2 + textOffset} // Position the text in the center of the bar
                      y={y + height / 2 + textOffset} // Position the text vertically centered
                      fill="#000" // Text color
                      fontSize={12}
                      textAnchor="middle" // Center the text horizontally
                      alignmentBaseline="middle" // Center vertically
                      transform={`rotate(270, ${x + width / 2}, ${y + height / 2})`}
                    >
                      60 min
                    </text>
                    
                    
                    </>

                  );
                }}>
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level0-4-${index}`} fill={entry.fillColor4} />
                  ))}
                </Bar>

                <Bar dataKey="Onehour_Negative" stackId="Onehour_Negative" barSize={20} yAxisId="left"  >
                  {chartData3.map((entry, index) => (
                    <Cell key={`cell-level1-4-${index}`} fill={entry.fillColor4} />
                  ))}
                </Bar>

                

                {/* <Area type="monotone" dataKey="Avg_Percentage_Movement" stroke="#ff7300" fill="#ff7300" fillOpacity={0.3} yAxisId="right" /> */}
                <Line type="monotone" dataKey="MovementAvgPercentage" stroke="#ff0000" strokeWidth={2} dot={{ r: 4 }} yAxisId="right" />
                
              </ComposedChart>
              <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
              <img
                src={baricon}
                alt="columnBars"
              
                className="h-[20px] w-[20px] "
                title="Column Bars"
                />
                  <h1 className="w-[200px]"> Currency correlation (%) : </h1>
                <div className="w-[55.03px]"><span style={{ background: '#f57474' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>0–65</div>
                <div className="w-[71.03px]"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>66-80</div>
                <div className="w-[51.66px]"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span> 80+</div>
                
                
                {/* <div className="w-[55.03px]"><span style={{ background: '#f57474' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div> */}
                </div>
                <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon2}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                <h1 className="w-[195px]">Average Movement (%)  : </h1>
                <div className="w-[55.03px] invisible"><span style={{ background: '#ff0000' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[71.03px] invisible"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[51.66px] invisible"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
               </div>
             
              </ResponsiveContainer>
              </div>

              </div>
              </>
            )}
          </div>
         
          </div>

          </div>


          {/* <----second column flat graphs all----> */}
          <div className="w-full items-center flex flex-col mt-10">
          
          <h1 className="font-bold text-[18px]">Flat event</h1>
          <div className="flex justify-around items-center flex-row w-[98%] border-4 px-2 py-4 border-[#D2C2F0] ">
          <div id="chart" className="w-[42%] ">
            {loading_forgraphs_1stGraph_flat ? (
              <p>No charts available for Flat Values </p>
            ) : noDataAvailable ? (
              <div className="h-[530px] flex items-center justify-center">
              <p>Data is not available for this graph</p>
              </div>
            ) 
            : (
            <>
            <div className="border rounded-md bg-[#fff] p-5 h-[530px]">
            <div className="flex justify-end items-center w-full">
               <div className="flex justify-start items-center m-4 border border-solid border-[#240d3a] w-[124px]">
                <p className="p-1 text-[13px]">Data Count : {dataCount_flat0}</p>
              
                </div>
               </div>
              <ReactApexChart
                options={state_1stGraph_flat.options}
                series={state_1stGraph_flat.series}
                type="line"
                height={350}
              />

          <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={baricon}
                alt="columnBars"
              
                className="h-[20px] w-[20px] "
                title="Column Bars"
                />
                  <h1 className="w-[195px]">Average Movement (%) : </h1>
                <div className="w-[55.03px]"><span style={{ background: '#f57474' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>0–299</div>
                <div className="w-[71.03px]"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>300–500</div>
                <div className="w-[51.66px]"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span> 500+</div>
                </div>
                <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                  <h1 className="w-[195px]">Average Movement (points) : </h1>
                <div className="">1min<span style={{ background: '#26e7a6' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">5min<span style={{ background: '#febc3b' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">15min<span style={{ background: '#fd5e76' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                <div className="">1hr<span style={{ background: '#8a60c2' }} className="inline-block w-3 h-3 rounded-full mr-1 ml-2"></span></div>
                </div>
              </div>
            </>
            )}
          </div>
         
          <div id="chart" className="w-[54%] ">
            {loading_forgraphs_3rdgraph_flat0 ? (
              <p>loading.... </p>
            ) : noDataAvailable_3rdgraph ? (
              <div className="h-[530px] flex items-center justify-center">
              <p>Data is not available for this graph</p>
              </div>
            ) : (
              <div className=" rounded-md bg-[#fff] p-5 h-[530px] ">
                <div className="flex justify-end items-center w-full">
               <div className="flex justify-start items-center m-4 border border-solid border-[#240d3a] w-[124px]" >
                <p className="p-1 text-[13px]">Data Count : {dataCount_flat0}</p>
              
                </div>
               </div>
               <div style={{ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "12px" ,  color: "black" }} className=" rounded-md bg-[#fff] p-5 text-black">

              <ResponsiveContainer width="100%" height={365} >
              <ComposedChart data={chartData3_flat0}  barCategoryGap="30%" barGap={2}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                    yAxisId="left"
                    tickFormatter={(value) => `${value} %`}
                    label={{
                      value: "Currency correlation (%)",
                      angle: -90,
                      position: "insideLeft",
                      style: { fill: "#686868" },
                      dy: 90 
                    }}
                  />

                  <YAxis
                    yAxisId="right"
                    orientation="right"
                    label={{
                      value: "Average Movement (%) ",
                      angle: 90,
                      position: "insideRight",
                      style: { fill: "#686868" },
                      dy: 90 // adjust this too
                    }}
                  />
                <Tooltip />

                <ReferenceLine
                  y={0}
                  yAxisId="left"
                  stroke="black"
                  // strokeWidth={2}
                  // strokeDasharray="5 5"
                  label={{
                    value: "",
                    position: "insideTopLeft",
                    fill: "black",
                    fontSize: 14,
                    fontWeight: "bold"
                  }}
                />

                {/* <Legend /> */}
                
                <Bar dataKey="Level0" stackId="Level0" barSize={20} yAxisId="left">
                  {chartData3_flat0.map((entry, index) => (
                    <Cell key={`cell-level0-${index}`} fill={entry.fillColor} />
                  ))}
                </Bar>

             
                <Bar dataKey="Level1" stackId="Level1" barSize={20} yAxisId="left">
                  {chartData3_flat0.map((entry, index) => (
                    <Cell key={`cell-level1-${index}`} fill={entry.fillColor} />
                  ))}
                </Bar>

                <Bar dataKey="Level0_2" stackId="Level0_2" barSize={20} yAxisId="left">
                  {chartData3_flat0.map((entry, index) => (
                    <Cell key={`cell-level0-2-${index}`} fill={entry.fillColor2} />
                  ))}
                </Bar>

                <Bar dataKey="Level1_2" stackId="Level1_2" barSize={20} yAxisId="left">
                  {chartData3_flat0.map((entry, index) => (
                    <Cell key={`cell-level1-2-${index}`} fill={entry.fillColor2} />
                  ))}
                </Bar>

                {/* <Area type="monotone" dataKey="Avg_Percentage_Movement" stroke="#ff7300" fill="#ff7300" fillOpacity={0.3} yAxisId="right" /> */}
                <Line type="monotone" dataKey="MovementAvgPercentage" stroke="#ff0000" strokeWidth={2} dot={{ r: 4 }} yAxisId="right" />
                
              </ComposedChart>
              <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
              <img
                src={baricon}
                alt="columnBars"
              
                className="h-[20px] w-[20px] "
                title="Column Bars"
                />
                  <h1 className="w-[200px]"> Currency correlation (%): </h1>
                <div className="w-[55.03px]"><span style={{ background: '#f57474' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>0–65</div>
                <div className="w-[71.03px]"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span>66-80</div>
                <div className="w-[51.66px]"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span> 80+</div>
               
                </div>
                <div className="flex gap-4 text-sm text-[#686868] mt-2 justify-center items-center">
                <img
                src={lineicon2}
                alt="Line"
              
                className="h-[20px] w-[20px] "
                title="Line"
                />
                <h1 className="w-[195px]">Average Movement (%)  : </h1>
                <div className="w-[55.03px]"><span style={{ background: '#ff0000' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[71.03px] invisible"><span style={{ background: '#f7da05' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
                <div className="w-[51.66px] invisible"><span style={{ background: '#61f393' }} className="inline-block w-3 h-3 rounded-full mr-1"></span></div>
               </div>
              </ResponsiveContainer>
              </div>
              </div>
            )}
          </div>


         
          </div>
          </div>

        </div>
        </>
      }
    
      </div>
    </>
  );
};

export default VisualisationComparePage;
